/**
 * The Hayfish mark: a fish whose body is a broadcast waveform.
 *
 * Drawn rather than generated. The Roku channel icon carries the same mark as
 * a raster (apps/roku/images/icon_focus_hd.png), but a nav bar needs it at
 * 26px on a dark ground and a favicon needs it at 16px, and a downscaled
 * photographic bloom turns to mush at both sizes. As SVG it is ~1kB, sharp on
 * every display, and recolourable.
 *
 * The gradient id is instance-scoped: two marks on one page (header and
 * footer) with the same id would make the second reference the first, and a
 * later unmount would blank whichever one survived.
 */
import { useId } from "react";

export function BrandMark({ size = 28 }: { size?: number }) {
  const gradientId = useId();
  return (
    <svg
      width={(size * 64) / 32}
      height={size}
      viewBox="0 0 64 32"
      aria-hidden="true"
      focusable="false"
      className="brandmark"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#3ee0ff" />
          <stop offset="0.55" stopColor="#8f7bff" />
          <stop offset="1" stopColor="#ff4fd0" />
        </linearGradient>
      </defs>
      <g fill={`url(#${gradientId})`}>
        <path d="M2 3.5 L13.5 16 L2 28.5 L6.2 16 Z" />
        <rect x="15" y="12.2" width="3" height="7.6" rx="1.5" />
        <rect x="19" y="11.6" width="3" height="8.8" rx="1.5" />
        <rect x="23" y="6.2" width="3" height="19.6" rx="1.5" />
        <rect x="27" y="9.4" width="3" height="13.2" rx="1.5" />
        <rect x="31" y="5" width="3" height="22" rx="1.5" />
        <rect x="35" y="8.6" width="3" height="14.8" rx="1.5" />
        <rect x="39" y="7.1" width="3" height="17.9" rx="1.5" />
        <rect x="43" y="11.7" width="3" height="8.6" rx="1.5" />
        <path d="M47 8.4 L61 16 L47 23.6 Z" />
      </g>
      {/* The eye is the page ground punched back through the head, so the mark
          works on any surface without a second colour. */}
      <circle cx="50.6" cy="14" r="1.5" className="brandmark__eye" />
    </svg>
  );
}
